import React from 'react';
import { useTranslation } from 'react-i18next';
import { MapContainer, TileLayer, Marker } from 'react-leaflet';
import { FaMapMarkerAlt } from 'react-icons/fa';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import './locationCompany.scss';

// Configuración de iconos personalizados
const createTransparentIcon = () => {
    return new L.Icon({
        iconUrl: 'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" fill="%23FFC310"><path d="M16 2C9.37 2 4 7.37 4 14c0 10.5 12 16 12 16s12-5.5 12-16c0-6.63-5.37-12-12-12z"/></svg>',
        iconSize: [25, 41],
        iconAnchor: [12, 41],
        popupAnchor: [1, -34],
        className: 'transparent-marker-icon'
    });
};

const locations = [
    {
        name: 'Madrid',
        coords: [40.41956, -3.69196],
        address: 'Calle de Alcalá, 45, 28014 Madrid, España'
    },
    {
        name: 'Valladolid',
        coords: [41.6528, -4.7244]
    },
    {
        name: 'Badajoz',
        coords: [38.8794, -6.9707]
    },
    {
        name: 'Elche',
        coords: [38.2699, -0.7126]
    },
];

// Control para mostrar u ocultar el mapa (oculto temporalmente: CARTO requiere API key)
const SHOW_MAP = false;

const LocationCompany = () => {
    const { t } = useTranslation();

    return (
        <div className="locationCompany">
            <div className="locationCompany__container">
                <div className="locationCompany__locations-list">
                    <div className="locationCompany__item">
                        <div className="locationCompany__icon-wrapper">
                            <FaMapMarkerAlt className="locationCompany__icon" />
                        </div>
                        <div className="locationCompany__text">
                            <h3 className="locationCompany__title">{t('contact.location.officesTitle')}</h3>
                            <h3 className="locationCompany__subtitle">{t('contact.location.officesSubtitle')}</h3>
                        </div>
                    </div>
                    <div className="locationCompany__item">
                        <div className="locationCompany__icon-wrapper">
                            <FaMapMarkerAlt className="locationCompany__icon" />
                        </div>
                        <div className="locationCompany__text">
                            <h3 className="locationCompany__title">{t('contact.location.visitTitle')}</h3>
                            <h3 className="locationCompany__subtitle">{t('contact.location.visitSubtitle')}</h3>
                        </div>
                    </div>
                </div>

                {/* Mapa - Oculto temporalmente porque CARTO requiere API key */}
                {SHOW_MAP && (
                    <div className="locationCompany__map-container">
                        <MapContainer
                            center={[40.4168, -3.7038]}
                            zoom={6}
                            scrollWheelZoom={false}
                            className="locationCompany__map"
                        >
                            <TileLayer
                                url="https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png"
                                opacity={1}
                            />
                            {locations.map(loc => (
                                <Marker
                                    key={loc.name}
                                    position={loc.coords}
                                    icon={createTransparentIcon()}
                                />
                            ))}
                        </MapContainer>
                    </div>
                )}
            </div>
        </div>
    );
};

export default LocationCompany;

/*<ul className="locationCompany__cities">
                    {locations.map(loc => (
                    <li key={loc.name} className="locationCompany__city">
                        {loc.name}
                    </li>
                    ))}
                </ul>*/ 